import "./product-details-info-left.scss";
import "components/jiffy/transfer-guides/transfer-guides";
import MadeStore from "components/jiffy/vue-product-details-print/store/store";

const $getProductDetailsSavingsItem = () =>
  document.querySelectorAll(".js-product-details-savings-item");
const $getProductDetailsBulkDiscountItem = () =>
  document.querySelectorAll(".js-product-details-bulk-discount");
const $getToggle = () =>
  document.querySelector(".js-product-details-info-left__bulk-discount-toggle");
const $getInfoLeftContainer = () => document.querySelector(".js-info-left");
const $getProductDetailsContainer = () => document.querySelector(".js-product-details-info");

const handleBulkDiscountTable = () => {
  const { madeSupport } = $getInfoLeftContainer()?.dataset || {};
  const madeMode = MadeStore.getters["app/mode"];

  const $items = [...$getProductDetailsSavingsItem(), ...$getProductDetailsBulkDiscountItem()];

  $items.forEach($item => {
    if (madeSupport === "false") {
      $item.classList.remove("hidden");
      return;
    }

    const { jiffyPrint } = $item.dataset;
    const shouldHide =
      (jiffyPrint === "blanks" && madeMode === "made") ||
      (jiffyPrint !== "blanks" && madeMode === "blanks");
    $item.classList.toggle("hidden", shouldHide);
  });
};

const initToggle = () => {
  const $toggle = $getToggle();

  if (!$toggle) return;

  $toggle.addEventListener("click", () => {
    document
      .querySelectorAll($toggle.dataset.target)
      .forEach($target => $target.classList.toggle("show"));
  });
};

const checkStickyProduct = () => {
  const $productDetailsContainer = $getProductDetailsContainer();
  const $infoLeftContainer = $getInfoLeftContainer();
  if (!$productDetailsContainer || !$infoLeftContainer) return;

  const isSticky = $infoLeftContainer.dataset.sticky === "true";
  if (!isSticky) return;

  const productDetailsContainerRect = $productDetailsContainer.getBoundingClientRect();
  $productDetailsContainer.style.minHeight = `${productDetailsContainerRect.height}px`;
  $infoLeftContainer.classList.add("lg:!sticky", "lg:top-[60px]", "lg:z-2");
};

export default () => {
  initToggle();

  handleBulkDiscountTable();
  checkStickyProduct();

  MadeStore.watch(state => state.app.mode, handleBulkDiscountTable);
};
